import { Link } from "react-router-dom";

const CITY_LINKS = [
  { name: "Carrollton, MO", to: "/blog/hotels-in-carrollton-mo" },
  { name: "Kansas City overflow", to: "/blog/kansas-city-to-chillicothe-stopover-carrollton" },
  { name: "Marshall, MO", to: "/blog/hotels-near-marshall-mo-van-meter-state-park" },
  { name: "Brunswick, MO", to: "/blog/worlds-largest-pecan-brunswick-missouri" },
  { name: "Chillicothe, MO", to: "/blog/hotels-near-chillicothe-missouri-sleeping-overflow" },
  { name: "Sumner / Swan Lake", to: "/blog/hotels-near-swan-lake-national-wildlife-refuge" },
  { name: "Norborne · Waverly · Keytesville & more", to: "/blog/small-towns-around-carrollton-mo" },
];

const TOPIC_LINKS = [
  { name: "Pet-friendly stays", to: "/blog/pet-friendly-hotels-carroll-county-missouri" },
  { name: "Truck parking", to: "/blog/trucker-parking-overnight-us-65-missouri" },
  { name: "Family travel", to: "/blog/family-friendly-hotels-mid-missouri-carrollton" },
  { name: "Group bookings", to: "/blog/group-bookings-weddings-reunions-carrollton-mo" },
  { name: "Corporate / extended stay", to: "/blog/extended-stay-corporate-housing-carrollton-mo" },
  { name: "Carrollton history", to: "/blog/history-of-carrollton-missouri" },
  { name: "Things to do", to: "/blog/things-to-do-in-carrollton-missouri" },
  { name: "Dining near hotel", to: "/blog/where-to-eat-carrollton-missouri" },
  { name: "Small-town day trips", to: "/blog/small-towns-around-carrollton-mo" },
];

export default function CitiesAndTopics() {
  return (
    <section className="bg-canvas py-20 md:py-28 border-t border-rule-subtle" data-testid="cities-topics-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="font-mono-label text-ember mb-4">Coverage map</p>
          <h2 className="font-display text-4xl md:text-5xl text-ink leading-[1.05]">
            One hotel.<br />
            <span className="italic">A region of reasons to stay.</span>
          </h2>
          <p className="mt-6 text-ink-soft leading-relaxed">
            We're the practical lodging anchor for half a dozen surrounding towns and a dozen
            different reasons people travel through Carroll County. Pick the entry point that fits
            why you're here.
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono-label text-ink-muted mb-5">Cities we serve</p>
          <ul className="space-y-3" data-testid="cities-list">
            {CITY_LINKS.map((c) => (
              <li key={c.to}>
                <Link to={c.to} className="link-underline text-ink hover:text-ember font-display text-xl" data-testid={`city-link-${c.to.split("/").pop()}`}>
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono-label text-ink-muted mb-5">Why people stay</p>
          <ul className="space-y-3" data-testid="topics-list">
            {TOPIC_LINKS.map((t) => (
              <li key={t.to}>
                <Link to={t.to} className="link-underline text-ink hover:text-ember font-display text-xl" data-testid={`topic-link-${t.to.split("/").pop()}`}>
                  {t.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
